import { BrowserRouter } from "react-router-dom";
import { App as AntdApp } from "antd";
import { ThemeProvider } from "./theme/ThemeProvider";
import { AuthProvider } from "./hooks/useAuth";
import { ComposeProvider } from "./components/ComposeContext";
import { AppRoutes } from "./routes";

export default function App() {
  return (
    <ThemeProvider>
      <AntdApp>
        <BrowserRouter>
          <AuthProvider>
            <ComposeProvider>
              <AppRoutes />
            </ComposeProvider>
          </AuthProvider>
        </BrowserRouter>
      </AntdApp>
    </ThemeProvider>
  );
}
